import type GetCoveragesBasicResponse from '@/modules/common/common/models/DXP/responses/GetCoveragesBasicResponse'
import GetCoveragesBasicRequest from '@/modules/common/common/models/DXP/requests/GetCoveragesBasicRequest'
import type CoveragesComplete from '@/modules/common/common/models/MID/CoveragesComplete'
import CoverageBasic from '@/modules/common/common/models/APP/CoverageBasic'

export default class {
  static toRequest(coverages: { coverageCode: string }[]): GetCoveragesBasicRequest {
    return new GetCoveragesBasicRequest({ language: 'es', coverages })
  }

  static fromResponse(
    DXPResponse: GetCoveragesBasicResponse[],
    MIDResponse: CoveragesComplete[]
  ): CoverageBasic[] {
    const coverages: CoverageBasic[] = []

    MIDResponse.forEach((MIDCoverage) => {
      const DXPCoverage = DXPResponse.find(
        (w) => w.coverage.coverageId === MIDCoverage.coverageCode
      )

      if (DXPCoverage) {
        coverages.push(
          new CoverageBasic({
            coverageCode: MIDCoverage.coverageCode,
            coverageNumber: MIDCoverage.coverageNumber,
            title: DXPCoverage.coverage.coverageName,
            shortDescription: DXPCoverage.coverage.coverageShortDescription,
            description: MIDCoverage.description,
            tooltip: DXPCoverage.coverage.coverageDescription,
            mandatory: MIDCoverage.mandatory,
            maxAge: MIDCoverage.maxAge,
            minAge: MIDCoverage.minAge,
            coverageInfoCapitals: MIDCoverage.coverageInfoCapitals
          })
        )
      } else {
        console.error(`DXP ${MIDCoverage.coverageCode} coverage required`)
      }
    })

    return coverages
  }
}
